<template>
  <div class="groups">
    <v-row>
      <v-col cols="12" sm="6">
        <div class="areaTitle">
          <h2>Groups</h2>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons"
            @click.stop="onAddNewGroup"
            class="mr-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new group
          </v-btn>
        </div>
        <v-card class="pa-2 groupsList" outlined tile>
          <v-data-table
            :headers="headers"
            v-model="selectedGroup"
            :items="groupsList"
            :loading="loading"
            :items-per-page="-1"
            :single-select="true"
            item-key="Id"
            @click:row="rowClick"
            dense
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6">
        <v-alert v-if="!isEditMode && !isSelectedGroupExists" outlined dense type="info">
          Please select group or add the new.
        </v-alert>
        <div v-else class="formContainer">
          <v-form ref="groupForm" v-model="isFormValid" lazy-validation class="groupForm">
            <FormPanel
              :formElements="formElements"
              :readOnly="!isEditMode"
              :calculationSelectionInputs="calculationSelectionInputs"
              @open-calculation-selection="openCalculationSelection"
            ></FormPanel>
          </v-form>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && isSelectedGroupExists"
                outlined
                color="error"
                @click="onDelete"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onEdit">Edit</v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onCancel">Cancel</v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="saveChanges"
                class="ml-4"
                :disabled="!isFormValid"
                >Save</v-btn
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox"></Dialog>
    <CalculationSelection
      ref="calculationSelection"
      @select="onSelect"
      :levelId="currentPlanId"
      :typeList="availableCalculationTypes"
    />
  </div>
</template>
<script>
import FormPanel from '@/components/FormPanel.vue';
import Dialog from '@/components/layout/Dialog.vue';
import Utils from '@/utils.js';
import CalculationSelection from './CalculationForms/Popups/CalculationSelection.vue';

export default {
  name: 'Groups',
  components: {
    Dialog,
    FormPanel,
    CalculationSelection,
  },
  data() {
    return {
      loading: false,
      readOnly: true,
      isEditMode: false,
      dialog: false,
      formElements: [],
      allElements: [],
      groupsList: [],
      selectedGroup: [],
      currentGroup: null,
      count: 0,
      headers: [{ text: 'Name', value: 'ShortName' }],
      isFormValid: false,
      calculationSelectionInputs: [
        'DateJoiningItem',
        'DateLifeCoverItem',
        'DatePensionStartItem',
        'NRAItem',
        'NRAFemaleItem',
        'DateRefundItem',
        'DateDeferredItem',
        'DateTOutItem',
        'DateTOutNonVestedItem',
      ],
      availableCalculationTypes: ['Date'],
      calculationSelectionProperty: null,
    };
  },
  mounted: function () {
    this.getGroupsList();
    this.getForm('Groups');
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    isSelectedGroupExists() {
      return this.selectedGroup && this.selectedGroup.length > 0;
    },
  },
  methods: {
    onAddNewGroup() {
      this.clearData();
      this.selectedGroup = [];
      this.isEditMode = true;
    },

    rowClick(item, row) {
      row.select(true);
      this.getGroup(item.Id);
    },
    onEdit() {
      this.isEditMode = true;
    },
    onCancel() {
      this.isEditMode = false;
      if (this.isSelectedGroupExists)
        Utils.setDataToFormElements(this.currentGroup, this.formElements);
      else this.clearData();
    },
    onDelete() {
      this.deleteGroup();
    },
    openCalculationSelection(fieldName) {
      this.calculationSelectionProperty = fieldName;
      const selectDialog = this.$refs.calculationSelection;
      selectDialog.open();
    },
    onSelect(val) {
      const formElement = this.formElements.find((x) => {
        return x.FieldName == this.calculationSelectionProperty;
      });
      if (formElement) {
        formElement.Value = val;
      }
      this.calculationSelectionProperty = null;
    },
    saveChanges() {
      const isFormValid = this.$refs.groupForm.validate();
      if (isFormValid) {
        if (this.isSelectedGroupExists) {
          this.updateGroup();
        } else {
          this.addNewGroup();
        }
      }
    },

    async getForm(formName) {
      try {
        let response = await this.$api.get(
          '/datadictionary/GetFormElements?formName=' + formName + '&planId=' + this.currentPlanId
        );
        this.allElements = response.data;
        if (response.data.length)
          this.formElements = response.data.filter((f) => f.Visible == true);
      } catch (err) {
        console.error(err);
      }
    },

    async getGroupsList(groupId) {
      try {
        this.loading = true;
        let response = await this.$api.get('/Groups/GetGroupList?planId=' + this.currentPlanId);
        var data = response.data;
        this.groupsList = data;
        this.loading = false;
        if (groupId && this.groupsList.length) {
          const selected = this.groupsList.find((x) => x.Id == groupId);
          if (selected) this.selectedGroup = [selected];
        }
      } catch (err) {
        this.loading = false;
        console.error(err);
      }
    },

    async getGroup(groupId) {
      try {
        let response = await this.$api.get('/Groups/GetGroupById', {
          params: { AddressId: groupId },
        });

        if (!response.data) {
          const msg = 'Unable to load group with id ' + groupId;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.currentGroup = response.data;
        var data = response.data;
        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },

    async addNewGroup() {
      const newGroup = {};
      this.allElements.forEach((el) => {
        newGroup[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newGroup[el.FieldName] = el.Value;
      });
      newGroup.GroupId = 0;
      newGroup.PlanId = this.currentPlanId;
      try {
        const response = await this.$api.post('/Groups/UpdateGroup', newGroup);
        const data = response.data;

        this.getGroupsList(data.Value);
        this.isEditMode = false;
      } catch (err) {
        console.log(err.message);
      }
    },

    async updateGroup() {
      try {
        const group = this.currentGroup;
        this.formElements.forEach((el) => {
          group[el.FieldName] = el.Value;
        });
        group.GroupStartString=group.GroupStart;
        group.GroupEndString=group.GroupEnd;
        await this.$api.post('/Groups/UpdateGroup', group);

        this.getGroupsList();
        this.isEditMode = false;
      } catch (err) {
        console.error(err);
      }
    },

    async deleteGroup() {
      try {
        await this.$refs.messageBox.open(
          'Confirmation',
          'Are you sure you wish to delete this record ?'
        );
        await this.$api.delete('/Groups/DeleteGroup?groupId=' + this.selectedGroup[0].Id);

        this.selectedGroup = [];
        this.clearData();
        this.getGroupsList();
      } catch (err) {
        console.error(err);
      }
    },

    clearData() {
      this.formElements.forEach(function (e) {
        e.Value = '';
      });
    },
  },
};
</script>
<style scoped>
.groups {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;
}

.groups .areaTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.groups .groupForm {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 12px;
}
</style>

<style lang="scss" scoped>
.formContainer {
  position: relative;
  height: 100%;

  .formFooter {
    bottom: 0;
    width: 100%;
    margin-top: 5px;

    position: sticky;
    background-color: white;
    padding: 8px 0 0 0;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btnContainer {
      display: flex;
    }
  }
}
</style>
